import constants from '../../../constants';
import { add } from '../notifications';
import { Notification } from 'state/middleware/notificationMiddleware';
import types from './types';

const { LOAD, LOAD_SUCCESS, LOAD_FAIL } = types;

const formatList = numbers => numbers.join(', ');

export function buildPaymentNotification(result) {
  if (!result || typeof result !== 'object') {
    return { messages: [{ id: 'notifications.requestPayment.successful' }], notificationType: 'success' };
  }

  const sms = (Array.isArray(result.sms) ? result.sms : [])
    .filter(s => s && typeof s === 'object' && typeof s.number === 'string');
  const sent = sms.filter(s => s.sent).map(s => s.number);
  const failed = sms.filter(s => !s.sent && !s.optedOut).map(s => s.number);
  const optedOut = sms.filter(s => s.optedOut).map(s => s.number);

  const messages = [];

  if (result.emailSent) {
    messages.push({ id: 'notifications.requestPayment.email.sent' });
  }

  if (sent.length > 0) {
    messages.push({ id: 'notifications.requestPayment.sms.sent', values: { numbers: formatList(sent) } });
  }

  if (failed.length > 0) {
    messages.push({ id: 'notifications.requestPayment.sms.failed', values: { numbers: formatList(failed) } });
  }

  if (optedOut.length > 0) {
    messages.push({
      id: 'notifications.requestPayment.sms.optedOut',
      values: { numbers: formatList(optedOut), optInNumber: constants.smsOptInNumber },
    });
  }

  if (messages.length === 0) {
    return { messages: [{ id: 'notifications.requestPayment.successful' }], notificationType: 'success' };
  }

  const anySucceeded = result.emailSent || sent.length > 0;
  return { messages, notificationType: anySucceeded ? 'success' : 'warning' };
}

export default function requestPayment(userId, data, token) {
  return dispatch => {
    const actionPromise = dispatch({
      types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
      promise: client => client.post(`/owners/${userId}/requestPayment`, { data, token }),
    });

    actionPromise.then(result => {
      const { messages, notificationType } = buildPaymentNotification(result);
      dispatch(add(new Notification(null, null, LOAD_SUCCESS, notificationType, undefined, undefined, messages)));
    }).catch(() => {
      // Errors are surfaced by errorMiddleware
    });

    return actionPromise;
  };
}
